// 资源信息-普通苗木
<template>
  <div class="main">
    <el-form ref="searchInfo" :model="info" class="global-form" :inline="true">
      <el-form-item>
        <el-select v-model="info.projectId" placeholder="请选择所属项目" filterable clearable>
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="plantName">
        <el-input v-model="info.plantName" placeholder="请输入苗木名称" clearable></el-input>
      </el-form-item>
      <el-form-item prop="seedlingType">
        <el-select v-model="info.seedlingType" filterable placeholder="请选择苗木类别" clearable>
          <el-option v-for="item in typeList" :key="item.dicCode" :label="item.dicValue"
            :value="item.dicCode"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="treeAge">
        <el-input v-model="info.treeAge" placeholder="请输入树龄" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <el-button @click='onAdd' type="primary" icon='el-icon-plus' v-show="$ButtonShow('YSL_ADD_01')">新增</el-button>
    <el-button class="mb20" @click='AddMaintenanceBatch' type="primary"
      v-show="$ButtonShow('YMTR_ADD_02')">批量添加养护档案</el-button>
    <el-button type="primary" @click="onExport" v-show="$ButtonShow('YSL_SEL_04')">
      <div class="importExport">
        <svg class="global-icon" aria-hidden="true">
          <use :xlink:href="'#icon-icon_obj_daochu'"></use>
        </svg>
        <span>导出</span>
      </div>
    </el-button>
    <el-button @click='isShowImport = true' type="primary" v-show="$ButtonShow('YSL_ADD_03')">
      <div class="importExport">
        <svg class="global-icon" aria-hidden="true">
          <use :xlink:href="'#icon-icon_obj_daoru'"></use>
        </svg>
        <span>导入</span>
      </div>
    </el-button>

    <el-button class="mb20" @click='AddMaintenanceBatch' type="primary"
      v-show="$ButtonShow('addRecord')">批量添加养护档案</el-button>
    <el-table class="global-table" stripe v-loading="loading" :data="tableData" max-height="550"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="所属项目" show-overflow-tooltip prop="projectName">
        <template v-slot="{ row }">
          <span>{{ row.projectState === '3' ? getState(row.projectState) + '—' + row.projectName :
            row.projectName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="苗木名称" show-overflow-tooltip prop="plantName"></el-table-column>
      <el-table-column label="苗木类别" show-overflow-tooltip prop="seedlingTypeName"></el-table-column>
      <el-table-column label="栽种时间" show-overflow-tooltip prop="plantDate" min-width="120px"></el-table-column>
      <el-table-column label="树龄" show-overflow-tooltip prop="treeAge"></el-table-column>
      <el-table-column label="数量" show-overflow-tooltip prop="fenceCode"></el-table-column>
      <el-table-column label="二维码" show-overflow-tooltip prop="qrCode" min-width="100px">
        <template v-slot="{ row }">
          <el-image class="qrCodeImg" :src="row.qrCode" :preview-src-list="[row.qrCode]">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="290px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onDetail(row.seedlingId)">查看</el-button>
          <el-button type="text" @click="onDownload(row.qrCode, row.plantName + '.png')"
            v-show="$ButtonShow('downloadCode')">下载二维码</el-button>
          <el-button type="text" @click="addMaintenance(row.seedlingId)"
            v-show="$ButtonShow('YMTR_ADD_01')">新增养护档案</el-button>
          <el-button type="text" @click="onUpdate(row.seedlingId)"
            v-show="$ButtonShow('YSL_EDT_01') && row.projectState !== '3'">编辑</el-button>
          <el-button type="text" @click="onDelete(row.seedlingId)" v-show="$ButtonShow('YSL_DEL_01')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <global-pagination @size-change="getData" @current-change="getData" :current-page.sync="page" :page-size.sync="size"
      :total="total">
    </global-pagination>
    <!-- 导入 -->
    <ImportData :isShowImport.sync="isShowImport" :isNeedProject="true" :importUrl="$apis.seedling.importYhSeedling"
      :tempUrl="'https://qn.maintain.base.gintell.cn/template/苗木导入模板.xlsx'" @onSuccess="onSearch"></ImportData>

    <div v-if="showDialog">
      <maintenance-dialog ref='maintenance' :showDialog="showDialog" :typeShow="true" :requiredContent="false"
        @close="closeDialog" @save="saveData" :isSeedling='!isBatch' :tipsShow='tipsShow' :formData="formData" />
    </div>
  </div>
</template>
<script>
import ImportData from '@/components/importTemplateData/Index.vue'
import MaintenanceDialog from '@/components/maintenanceDialog/Index.vue'
export default {
  name: 'Seedling',
  components: { ImportData, MaintenanceDialog },
  data() {
    return {
      info: {
        projectId: '',
        plantName: '',
        seedlingType: '',
        treeAge: ''
      },
      loading: false,
      tableData: [],
      typeList: [],
      isShowImport: false,
      page: 1,
      size: 10,
      total: 0,
      selects: [],
      currentSeedlingId: '',
      formData: {
        maintainDate: '',
        maintainContent: '',
        fileList: [],
        maintainTypeIds: [],
        maintainStatus: '',
        chestDiameter: '',
        crownWidth: '',
        treeHeight: '',
        qualityLevel: '',
        valueAssessment: ''
      },
      isBatch: false,
      tipsShow: false,
      showDialog: false
    }
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    }
  },
  created() {
    console.log('buttonList', this.$store.state.buttonList)
    this.getTypeList()
    this.getData()
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    // 查询苗木类别列表
    getTypeList() {
      this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'seedlingType' }).then(res => {
        this.typeList = res.seedlingType || []
      })
    },
    getData() {
      this.loading = true
      this.$axios.get(this.$apis.seedling.selectYhSeedlingByPage, {
        ...this.info,
        isFamous: '0',
        page: this.page,
        size: this.size
      }).then(res => {
        this.total = res.total || 0
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    // 导出
    onExport() {
      const loading = this.$loading({
        lock: true,
        text: '下载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$axios.downloadFile(this.$apis.seedling.exportSeedlingData, { isFamous: '0', ...this.info }).finally(() => {
        loading.close()
      })
    },
    onAdd() {
      this.$router.push({
        name: 'seedlingAdd'
      })
    },
    // 批量添加养护记录
    AddMaintenanceBatch() {
      if (this.selects && this.selects.length > 0) {
        this.isBatch = true
        this.tipsShow = true
        this.showDialog = true
        this.formData = {
          maintainDate: '',
          maintainContent: '',
          fileList: [],
          maintainTypeIds: []
        }
      } else {
        this.$message.warning('未选中苗木信息，无法批量维护')
      }
    },
    // 勾选更改
    handleSelectionChange(val) {
      this.selects = val
    },
    // 添加养护记录
    addMaintenance(id) {
      this.currentSeedlingId = id
      this.showDialog = true
      this.getRecord(id)
    },
    // 获取最新苗木养护档案
    getRecord(id) {
      this.$axios.get(this.$apis.seedling.selectYhMaintainRecordByPage, {
        page: 1,
        size: 1,
        objectId: id,
        isNewest: 1
      }).then((res) => {
        // console.log('范胡子', res)s
        if (res.list && res.list.length) {
          const newRecord = res.list[0]
          this.formData = {
            maintainDate: '',
            maintainContent: '',
            fileList: [],
            maintainStatus: newRecord.maintainStatus,
            chestDiameter: newRecord.chestDiameter,
            qualityLevel: newRecord.qualityLevel,
            valueAssessment: newRecord.valueAssessment,
            crownWidth: newRecord.crownWidth,
            treeHeight: newRecord.treeHeight,
            maintainTypeIds: []
          }
        }
      })
    },
    saveData(formData) {
      let url = this.$apis.seedling.insertYhMaintainRecord
      let info = { objectId: this.currentSeedlingId }
      if (this.isBatch) {
        url = this.$apis.seedling.insertAllYhMaintainRecord
        info = { objectIds: [] }
        this.selects.forEach(item => {
          info.objectIds.push(item.seedlingId)
        })
      }
      this.$axios.post(url, {
        ...info,
        ...formData
      }).then(() => {
        this.$message.success('添加成功')
        this.getData()
      }).finally(() => {
        this.showDialog = false
        this.isBatch = false
        this.tipsShow = false
        this.formData = {
          maintainDate: '',
          maintainContent: '',
          fileList: [],
          maintainTypeIds: [],
          maintainStatus: '',
          chestDiameter: '',
          crownWidth: '',
          treeHeight: '',
          qualityLevel: '',
          valueAssessment: ''
        }
      })
    },
    closeDialog() {
      this.showDialog = false
      this.isBatch = false
      this.tipsShow = false
      this.formData = {}
    },
    onUpdate(seedlingId) {
      this.$router.push({
        name: 'seedlingUpdate',
        params: { seedlingId }
      })
    },
    onDelete(id) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.seedling.deleteYhSeedling, {
          seedlingId: id
        }).then(() => {
          this.$message.success('删除成功')
          this.page = 1
          this.getData()
        })
      })
    },
    onDetail(seedlingId) {
      this.$router.push({
        path: `/seedlingList/list/detail${seedlingId}`
      })
    },
    onDownload(url, fileName) {
      window.open(url + '?attname=' + fileName)
    },
    onSearch() {
      this.page = 1
      this.getData()
    },
    getState(state) {
      const arr = ['', '未开工', '在建', '已移交']
      return arr[Number(state)]
    }
  }
}
</script>

<style scoped lang="scss">
.main {
  width: 100%;
  padding: 20px 40px;
  border-top: 1px solid #F4F4F4;
}

.qrCodeImg {
  width: 50px;
  height: 50px;

  ::v-deep .el-image__error {
    font-size: 12px !important;
  }
}
</style>
